import { fetch } from '../request'
import type { IResponse, RequestConfig } from '../interface'
import type { BannerData } from '../interface/activityCenter'

export const getBanner = (config?: RequestConfig) => {
  return fetch<IResponse<BannerData[]>>('/promotion_center/banner/', {
    method: 'GET',
    params: { is_active: true },
    ...config,
  })
}
